import { configureStore } from '@reduxjs/toolkit';
import { appSlice } from './XSifterAppReducer';

export const xsifterAppStore = configureStore({
    reducer: {
        app: appSlice.reducer,
    },
    devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof xsifterAppStore.getState>;
export type AppDispatch = typeof xsifterAppStore.dispatch;

export default xsifterAppStore;
